import { render, staticRenderFns } from "./CourseDayFilters.vue?vue&type=template&id=5a482c64&lang=pug&"
import script from "./CourseDayFilters.vue?vue&type=script&lang=js&"
export * from "./CourseDayFilters.vue?vue&type=script&lang=js&"
import style0 from "./CourseDayFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
